// extracted by mini-css-extract-plugin
module.exports = {"form":"form_form__bQwqA","categories":"form_categories__pJ_Te","chevron":"form_chevron__uX4JO"};